class CourseContent {
  constructor({ courseID, title, description, thumbnail, content, isVideo, isRating, isConsent, id }) {
    this.courseID = courseID;
    this.title = title;
    this.description = description;
    this.thumbnail = thumbnail;
    this.content = content;
    this.isVideo = isVideo;
    this.isRating = isRating;
    this.isConsent = isConsent;
    this.id = id;
  }

  static fromJson(json) {
    return new CourseContent({
      courseID: json['courseID'],
      title: json['title'],
      description: json['description'],
      thumbnail: json['thumbnail'],
      content: json.hasOwnProperty('video') ? json['video'] : json['quiz'],
      isVideo: json['isVideo'],
      isRating: json.hasOwnProperty('isRating') ? json['isRating'] : false,
      isConsent: json.hasOwnProperty('isConsent') ? json['isConsent'] : false,
      id: json['_id']
    });
  }
}



export default CourseContent;
